/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant

*/
import dashboard from './dashboard'
import users from './users'
import food from './food'
import others from './others'
import diet from './diet'
import activity from './activity'
import order from './order'
import ticket from './ticket'
import banner from './banner'
import notification from './notification'
import checkErrors from './checkErrors'
import dedicatedDiet from './dedicatedDiet'
import affiliate from './affiliate'

// import others from './others'

import blog from './blog'
import hero from './hero'
import campaign from "./campaign";
// import messenger from "./messenger"

// Array of sections
export default [
  ...dashboard,
  ...users,
  ...food,
  ...diet,
  ...dedicatedDiet,
  ...activity,
  ...blog, 
  ...order,
  ...affiliate,
  ...others,
  ...ticket,
  ...banner,
  ...notification,
  ...checkErrors,
  ...hero,
  ...campaign,
  // ...messenger
]
